var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeGalleryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 50.6667V6.33333C57 2.85 54.15 0 50.6667 0H6.33333C2.85 0 0 2.85 0 6.33333V50.6667C0 54.15 2.85 57 6.33333 57H50.6667C54.15 57 57 54.15 57 50.6667ZM17.4167 33.25L25.3333 42.7817L36.4167 28.5L50.6667 47.5H6.33333L17.4167 33.25Z",
    fill: "#FFA826"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeGalleryIcon);
export default __webpack_public_path__ + "static/media/orangeGalleryIcon.a33a1232459dbe3a9c1365ff94181a2e.svg";
export { ForwardRef as ReactComponent };